import React from "react";
import PropTypes from "prop-types";

import { DhlButton, DhlGridContainer } from "@dhl-official/react-library";
import { Variants } from "@dhl-official/stencil-library";
import { isScrollEnabled } from "one-time-shipment/src/helpers/isScrollDisabled";
import scrollToComponent from "react-scroll-to-component";
import { IntlPropType } from "root/libs/core-libs/src";
import Globalization from "iconsMultiColor/cx/globalization.png";
import {
  DhlImageStyled,
  NoOffersWrapper,
  NoOffersTitle,
  NoOffersResultDescription,
} from "./styled";

export const NoOffersResponse = ({ backToShipmentLaneReference, intl }) => {
  const onButtonClick = (e) => {
    if (backToShipmentLaneReference.current !== null) {
      e.preventDefault();

      if (isScrollEnabled()) {
        scrollToComponent(backToShipmentLaneReference.current, {
          offset: -100,
          align: "top",
        });
      }

      const formInput = backToShipmentLaneReference.current.props.formReference.current.querySelector(
        "input"
      );

      if (formInput) {
        formInput.focus();
      }
    }
  };

  return (
    <NoOffersWrapper>
      <DhlGridContainer
        columns={1}
        isFullWidth
        aria-live="polite"
        data-testid="no-offers-response"
      >
        <DhlImageStyled src={Globalization} />
        <NoOffersTitle weight={700} class="no-offers-title">
          {intl.formatMessage({
            id: `SS.EmptyOffers.noOffersResultTitle`,
          })}
        </NoOffersTitle>
        <NoOffersResultDescription weight={400}>
          {intl.formatMessage({
            id: `SS.EmptyOffers.noOffersResultDescription`,
          })}
        </NoOffersResultDescription>
        <DhlButton
          variant={Variants.primary}
          onClick={onButtonClick}
          dataTestid="noOffersButton"
        >
          {intl.formatMessage({
            id: `SS.EmptyOffers.noOffersResultButtonText`,
          })}
        </DhlButton>
      </DhlGridContainer>
    </NoOffersWrapper>
  );
};

NoOffersResponse.propTypes = {
  backToShipmentLaneReference: PropTypes.object,
  intl: IntlPropType.isRequired,
};
